import { DashboardUser } from '@/model';
import {
  GetDashboardUserItemResponse,
  GetDashboardUserResponse,
  GetDashboardUserByIdResponse,
  PostDashboardUserResponse,
} from '@/services/response/dashboard-user';

export class DashboardUserConverter {
  static toDomainFromGetItemResponse(response: GetDashboardUserItemResponse): DashboardUser {
    return {
      uuid: response.uuid,
      email: response.email,
      phone_number: response.phone_number,
      status: response.status,
      business_unit_uuid: response.business_unit_uuid,
      name: response.name,
      document: response.document,
      created_at: response.created_at,
      updated_at: response.updated_at,
      avatar_url: response.avatar_url,
    };
  }

  static toDomainFromPaginatedResponse(response: GetDashboardUserResponse): DashboardUser[] {
    return response.data.map(DashboardUserConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromPostResponse(response: PostDashboardUserResponse): DashboardUser {
    return {
      uuid: response.uuid,
      email: response.email,
      phone_number: response.phone_number,
      status: response.status,
      business_unit_uuid: response.business_unit_uuid,
      name: response.name,
      document: response.document,
      created_at: response.created_at,
      updated_at: response.updated_at,
      avatar_url: response.avatar_url,
    };
  }

  static toDomainFromByIdResponse(response: GetDashboardUserByIdResponse): DashboardUser {
    return {
      uuid: response.uuid,
      email: response.email,
      phone_number: response.phone_number,
      status: response.status,
      business_unit_uuid: response.business_unit_uuid,
      name: response.name,
      document: response.document,
      created_at: response.created_at,
      updated_at: response.updated_at,
      avatar_url: response.avatar_url,
    };
  }
}
